<template>
  <v-main>
    <v-btn-toggle v-model="toggle_exclusive1" mandatory style="width:100%;">
      <v-col fluid cols="12" class="pr-1">
        <v-row class="my-2">
          <v-btn
            :color="col[0]"
            :value="1"
            class="rounded-r-xl black--text text-capitalize"
            style="font-size:0.7vw;"
            tile
            depressed
            width="100%"
            @click="sw(0)"
            max-height="35"
          >
            <v-row>
              <v-col cols="3">
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="9" align="start">
                <v-icon size="24" class="pr-3">account_circle</v-icon>Главная
              </v-col>
            </v-row>
          </v-btn>
        </v-row>
        <v-row class="my-2">
          <v-btn
            :color="col[1]"
            :value="2"
            class="rounded-r-xl black--text text-capitalize"
            style="font-size:0.7vw;"
            tile
            depressed
            width="100%"
            @click="sw(1)"
            max-height="35"
          >
            <v-row>
              <v-col cols="3">
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="9" align="start">
                <v-icon size="24" class="pr-2">speaker_notes</v-icon>
                {{title()}}
              </v-col>
            </v-row>
          </v-btn>
        </v-row>
        <v-row class="my-2">
          <v-btn
            :color="col[2]"
            :value="3"
            class="rounded-r-xl black--text text-capitalize"
            style="font-size:0.7vw;"
            tile
            depressed
            width="100%"
            @click="sw(2)"
            max-height="35"
          >
            <v-row>
              <v-col cols="3">
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="9" align="start">
                <v-icon size="24" class="pr-3">extension</v-icon>Проекты
              </v-col>
            </v-row>
          </v-btn>
        </v-row>
        <v-row class="my-2">
          <v-btn
            :color="col[3]"
            :value="4"
            class="rounded-r-xl black--text text-capitalize"
            style="font-size:0.7vw;"
            tile
            depressed
            width="100%"
            @click="sw(3)"
            max-height="35"
          >
            <v-row>
              <v-col cols="3">
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="9" align="start">
                <v-icon size="24" class="pr-3">question_answer</v-icon>Диалоги
              </v-col>
            </v-row>
          </v-btn>
        </v-row>
      </v-col>
    </v-btn-toggle>
  </v-main>
</template>

<script>
import {Exemplemix} from '../../mixinEx'
export default {
  mixins:[Exemplemix],
  props: ["token", "toggle_exclusive"],
  data: () => ({
    col: ["white", "white", "white", "white"],
    toggle_exclusive1: undefined,
  }),
  created() {
    for (var l = 0; l < this.col.length; l++) {
      if (l == this.toggle_exclusive - 1) {
        this.col[l] = "#FFCF36";
      }
    }
    this.toggle_exclusive1 = this.toggle_exclusive;
  },
  methods: {
    sw(e) {
      this.col[e] = "#FFCF36";
      for (var l = 0; l < this.col.length; l++) {
        if (l != e) {
          this.col[l] = "white";
        }
      }
      if (e == 0) {
        this.jump("/");
      } else if (e == 1) {
        this.jump('/Lk/1')
      } else if (e == 2) {
        this.jump("/Projects");
      } else if (e == 3) {
        this.jump("/Message/1");
      }
    },
    title() {
      if (this.token == 1) {
        return "Личная информация";
      } else if (this.token == 2) {
        return "Информация компании";
      } else {
        return "Информация ВУЗа";
      }
    },
  },
};
</script>